import React from "react";
import PropTypes from "prop-types";

const Centered = ({ children, height }) => (
  <div className="d-flex h-100 justify-content-center">
    <div className="row align-items-center" style={{ height: height }}>
      {children}
    </div>
  </div>
);

Centered.propTypes = {
  children: PropTypes.object.isRequired,
  height: PropTypes.string.isRequired
};

export default Centered;
